import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { API_URL } from '~/api/constants';
import { company } from '~/company/Company';

import { mainStore } from '~/stores';

import Section from '../../../components/Section';

import styles from './CustomerCare.module.css';

export const CustomerCare: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (import.meta.env.SSR) {
      return;
    }
    const handleMessage = (event: MessageEvent) => {
      if (event.data?.type === 'NAVIGATE') {
        navigate(event.data.path);
      }

      if (event.data?.type === 'SHOW_TOAST') {
        mainStore.pushAlert(
          event.data.payload.toastType,
          event.data.payload.message,
        );
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [navigate]);

  return (
    <div className={styles.customerCare}>
      <Section>
        <iframe
          src={`https://jam-customer-care-hub.lovable.app/customer-care?&baseApiUrl=${API_URL}&companyId=${company.config.id}`}
          className={styles.iframe}
          title="Customer Care"
        />
      </Section>
    </div>
  );
};
